import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/feature/Header';
import Footer from '../components/feature/Footer';
import BoldLabel from '../components/BoldLabel';
import { trackEvent } from '../lib/analytics';

const SECTION1 = ['austria', 'hungary', 'slovenia', 'switzerland'];
const SECTION2 = ['czechia', 'slovakia', 'romania', 'bulgaria'];

export default function BlogMotorcyclePage() {
  const { t } = useTranslation();

  useEffect(() => {
    trackEvent('blog_article_view', {
      article_slug: 'motorcycle-vignette-rules',
      article_category: 'basics',
      read_time_min: 3,
    });
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 bg-bg">
        <div className="mx-auto max-w-3xl px-5 py-14">
          <span className="inline-flex rounded-full bg-primary-soft px-3 py-1 text-[12px] font-medium text-primary">{t('blog.post5.category')}</span>
          <h1 className="mt-3 text-[26px] font-bold tracking-tight">{t('blog.post5.title')}</h1>
          <p className="mt-2 text-[14px] text-muted">{t('blog.post5.readTime')}</p>
          <div className="mt-8 space-y-5 text-[15px] leading-relaxed text-ink-soft">
            <p>{t('blog.post5.body.p1')}</p>

            <h3 className="text-[18px] font-semibold text-ink mt-6">{t('blog.post5.body.section1.heading')}</h3>
            <ul className="list-disc pl-5 space-y-2">
              {SECTION1.map((c) => (
                <li key={c}><BoldLabel text={t(`blog.post5.body.section1.line.${c}`)} /></li>
              ))}
            </ul>

            <h3 className="text-[18px] font-semibold text-ink mt-6">{t('blog.post5.body.section2.heading')}</h3>
            <ul className="list-disc pl-5 space-y-2">
              {SECTION2.map((c) => (
                <li key={c}><BoldLabel text={t(`blog.post5.body.section2.line.${c}`)} /></li>
              ))}
            </ul>

            <h3 className="text-[18px] font-semibold text-ink mt-6">{t('blog.post5.body.section3.heading')}</h3>
            <p>{t('blog.post5.body.section3.body')}</p>

            <h3 className="text-[18px] font-semibold text-ink mt-6">{t('blog.post5.body.section4.heading')}</h3>
            <p>{t('blog.post5.body.section4.body')}</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
